import React from "react";

const ExpandDown = ({ isActive }: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.8" cx="8" cy="8" r="8" fill="#5F67E0" />
      <path
        d="M3.2274 5.96959C3.36805 5.82899 3.55878 5.75 3.75765 5.75C3.95653 5.75 4.14726 5.82899 4.2879 5.96959L8.0004 9.68209L11.7129 5.96959C11.8544 5.83297 12.0438 5.75738 12.2405 5.75908C12.4371 5.76079 12.6252 5.83967 12.7643 5.97873C12.9033 6.11778 12.9822 6.30589 12.9839 6.50254C12.9856 6.69919 12.91 6.88864 12.7734 7.03009L8.53065 11.2728C8.39001 11.4134 8.19928 11.4924 8.0004 11.4924C7.80153 11.4924 7.6108 11.4134 7.47015 11.2728L3.2274 7.03009C3.0868 6.88944 3.00781 6.69871 3.00781 6.49984C3.00781 6.30097 3.0868 6.11024 3.2274 5.96959Z"
        fill="white"
      />
    </svg>
  );
};

export default ExpandDown;
